import { EntityStateModel } from 'app/projects/entity/src/lib/models/entity.state-model';
import { PartialGrade } from './partial-grade.model';

export class PartialGradeStateModel extends EntityStateModel<PartialGrade> {}
